export default "__VITE_ASSET__uGDD$3LD__"